/* Arditi Product Card Consolidated Modules */
/* 1. Grid Controls Module */
(function () {
    if (window.MBK_ARD_GRID_LOADED) return;
    window.MBK_ARD_GRID_LOADED = true;

    const STORAGE_KEY = 'ardCollectionGridCols';
    const STORAGE_KEY_STATE = 'ardCollectionGridState';
    const root = document.documentElement;

    function currentBreakpoint() {
      const w = window.innerWidth || document.documentElement.clientWidth;
      if (w <= 374) return 'xxs';
      if (w <= 767) return 'xs';
      if (w <= 1024) return 'sm';
      if (w <= 1439) return 'md';
      return 'lg';
    }
    function defaultColsFor(bp) {
      if (bp === 'xxs') return 1;
      if (bp === 'xs') return 1;
      if (bp === 'sm') return 2;
      if (bp === 'md') return 3;
      return 4;
    }
    function allowedCols(bp) {
      if (bp === 'xxs') return [1];
      if (bp === 'xs') return [1];
      if (bp === 'sm') return [1, 2];
      if (bp === 'md') return [2, 3, 4];
      return [2, 3, 4];
    }
    function readState() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY_STATE);
        if (raw) return JSON.parse(raw);
      } catch (e) {}
      try {
        const n = parseInt(localStorage.getItem(STORAGE_KEY), 10);
        if ([1, 2, 3, 4].includes(n)) return { val: n, bp: null, override: true };
      } catch (e) {}
      return { val: null, bp: null, override: false };
    }
    function writeState(state) {
      try {
        localStorage.setItem(STORAGE_KEY_STATE, JSON.stringify(state));
        localStorage.setItem(STORAGE_KEY, String(state.val));
      } catch (e) {}
    }
    function applyGridCols(n) {
      ['ard-collection-grid-1', 'ard-collection-grid-2', 'ard-collection-grid-3', 'ard-collection-grid-4'].forEach(
        (c) => root.classList.remove(c)
      );
      if ([1, 2, 3, 4].includes(n)) root.classList.add('ard-collection-grid-' + n);

      const bar = document.querySelector('.ard-collection-toolbar-row');
      if (bar) {
        bar.querySelectorAll('.ard-collection-grid-btn').forEach((b) => {
          const active = parseInt(b.dataset.cols, 10) === n;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
    }
    function enforceForViewport() {
      const bp = currentBreakpoint();
      const allow = allowedCols(bp);
      const def = defaultColsFor(bp);
      const state = readState();
      const overrideValid = state.override && state.bp === bp && allow.includes(state.val);
      const nextVal = overrideValid ? state.val : def;
      applyGridCols(nextVal);
      writeState({ val: nextVal, bp: bp, override: overrideValid });
    }
    function buildToolbar() {
      const el = document.createElement('div');
      el.className = 'ard-collection-toolbar-row';
      el.innerHTML = `
        <div class="ard-collection-toolbar-right ard-collection-grid-view">
          <span class="ard-collection-grid-view__label">Views:</span>
      <button type="button" class="ard-collection-grid-btn" data-cols="1" aria-label="1" title="1" aria-pressed="false">
        <span class="sr-only">1 column</span>
        <svg viewBox="0 0 269.09 366.95" aria-hidden="true" focusable="false">
          <g><rect x="0" y="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/></g>
        </svg>
      </button>
      <span class="ard-collection-grid-sep sep-12" aria-hidden="true">|</span>
      <button type="button" class="ard-collection-grid-btn" data-cols="2" aria-label="2 columns" title="2 columns" aria-pressed="false">
        <span class="sr-only">2 columns</span>
        <svg viewBox="0 0 576.67 366.95" aria-hidden="true" focusable="false">
          <g>
            <rect x="0" y="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
            <rect x="307.57" y="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
          </g>
        </svg>
      </button>
      <span class="ard-collection-grid-sep sep-23" aria-hidden="true">|</span>
      <button type="button" class="ard-collection-grid-btn" data-cols="3" aria-label="3 columns" title="3 columns" aria-pressed="false">
        <span class="sr-only">3 columns</span>
        <svg viewBox="0 0 884.24 366.95" aria-hidden="true" focusable="false">
          <g>
            <rect x="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
            <rect x="307.57" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
            <rect x="615.15" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
          </g>
        </svg>
      </button>
      <span class="ard-collection-grid-sep sep-34" aria-hidden="true">|</span>
      <button type="button" class="ard-collection-grid-btn" data-cols="4" aria-label="4 columns" title="4 columns" aria-pressed="false">
        <span class="sr-only">4 columns</span>
        <svg viewBox="0 0 1191.82 366.95" aria-hidden="true" focusable="false">
          <g>
            <rect x="0" y="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
            <rect x="307.57" y="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
            <rect x="615.15" y="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
            <rect x="922.72" y="0" width="269.09" height="366.95" rx="49.33" ry="49.33"/>
          </g>
        </svg>
      </button>
        </div>
      `;
      el.addEventListener('click', (e) => {
        const btn = e.target.closest('.ard-collection-grid-btn');
        if (!btn) return;
        const cols = parseInt(btn.dataset.cols, 10);
        const bp = currentBreakpoint();
        if (allowedCols(bp).includes(cols)) {
          applyGridCols(cols);
          writeState({ val: cols, bp: bp, override: true });
        }
      });
      return el;
    }

    const GRID_SELECTORS = [
      '[data-products-grid]',
      '.cc-product-list',
      '.productgrid--items',
      '.collection__products',
      '.collection-product-grid',
      '.collection-grid',
      '.product-grid',
      '.theme-filter-container .product-list',
    ];
    function findGrid() {
      for (const sel of GRID_SELECTORS) {
        const el = document.querySelector(sel);
        if (el && el.querySelector('.cc-product-block')) return el;
      }
      return null;
    }
    function ensureToolbar() {
      const bp = currentBreakpoint();
      if (bp === 'xxs' || bp === 'xs') {
        const existingBars = document.querySelectorAll('.ard-collection-toolbar-row, .ard-collection-grid-view');
        existingBars.forEach((b) => b.remove());
        enforceForViewport();
        return;
      }
      const grid = findGrid();
      if (!grid) return;
      const bars = Array.from(document.querySelectorAll('.ard-collection-toolbar-row'));
      for (let i = 1; i < bars.length; i++) bars[i].remove();
      let bar = bars[0];
      if (!bar) {
        bar = buildToolbar();
        if (bar && grid.parentNode) {
          grid.parentNode.insertBefore(bar, grid);
        }
      } else {
        if (bar.parentNode !== grid.parentNode || bar.nextElementSibling !== grid) {
          grid.parentNode.insertBefore(bar, grid);
        }
      }
      enforceForViewport();
    }
    function injectInitial() {
      ensureToolbar();
    }

    const SAFE_EVENTS = [
      'DOMContentLoaded',
      'shopify:section:load',
      'cc-collection-filter:rendered',
      'ajaxinate:loaded',
      'infiniteScroll:loaded',
      'popstate',
    ];
    SAFE_EVENTS.forEach((ev) => document.addEventListener(ev, () => setTimeout(ensureToolbar, 60)));

    let resizeTO = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(enforceForViewport, 120);
    });

    document.addEventListener('DOMContentLoaded', injectInitial);

    const mo = new MutationObserver((mutations) => {
      let should = false;
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n && n.nodeType === 1) {
            if (
              (n.matches && (GRID_SELECTORS.some((sel) => n.matches(sel)) || n.matches('.cc-product-block'))) ||
              (n.querySelector &&
                (n.querySelector('.cc-product-block') || GRID_SELECTORS.some((sel) => n.querySelector(sel))))
            ) {
              should = true;
              break;
            }
          }
        }
        if (should) break;
        for (const n of m.removedNodes) {
          if (n && n.nodeType === 1) {
            if (n.matches && (n.matches('.ard-collection-grid-view') || GRID_SELECTORS.some((sel) => n.matches(sel)))) {
              should = true;
              break;
            }
            if (
              n.querySelector &&
              (n.querySelector('.ard-collection-grid-view') || GRID_SELECTORS.some((sel) => n.querySelector(sel)))
            ) {
              should = true;
              break;
            }
          }
        }
        if (should) break;
      }
      if (should) setTimeout(ensureToolbar, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();

/* 2. Auto-Title Reveal Module */
(function initArditiAutoTitleRevealModule() {
    if (window.__ARDITI_AUTO_TITLE_REVEAL_LOADED__) return;
    window.__ARDITI_AUTO_TITLE_REVEAL_LOADED__ = true;

    function checkRowOverflow(row) {
      if (!row) return 0;
      var viewport = row.querySelector('.ard-title-viewport');
      var inner = row.querySelector('.ard-title-inner');
      if (!viewport || !inner) return 0;

      var prevTransition = inner.style.transition;
      var prevTransform = inner.style.transform;
      inner.style.transition = 'none';
      inner.style.transform = 'none';

      var viewportWidth = viewport.clientWidth;
      var textWidth = inner.scrollWidth;
      var overflow = textWidth - viewportWidth;

      inner.style.transition = prevTransition;
      inner.style.transform = prevTransform;

      if (overflow > 3) {
        var dist = Math.ceil(overflow + 8);
        var duration = Math.max(1.6, Math.min(6.5, dist / 30));
        row.classList.add('has-overflow');
        row.style.setProperty('--ard-overflow-dist', dist + 'px');
        row.style.setProperty('--ard-overflow-dur', duration.toFixed(2) + 's');
        row._ardOverflowDist = dist;
        row._ardOverflowDur = duration;
        return dist;
      } else {
        row.classList.remove('has-overflow', 'is-scrolling-forward', 'is-returning');
        row.style.removeProperty('--ard-overflow-dist');
        row.style.removeProperty('--ard-overflow-dur');
        row._ardOverflowDist = 0;
        return 0;
      }
    }

    function resetRowAnimation(row) {
      if (!row) return;
      if (row._ardStartTimer) {
        clearTimeout(row._ardStartTimer);
        row._ardStartTimer = null;
      }
      if (row._ardPauseTimer) {
        clearTimeout(row._ardPauseTimer);
        row._ardPauseTimer = null;
      }
      if (row._ardReturnTimer) {
        clearTimeout(row._ardReturnTimer);
        row._ardReturnTimer = null;
      }
      row.classList.remove('is-scrolling-forward', 'is-returning');
      var inner = row.querySelector('.ard-title-inner');
      if (inner) {
        inner.style.transform = '';
      }
    }

    function playAutoRevealCycle(row) {
      if (!row) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      resetRowAnimation(row);

      var dist = checkRowOverflow(row);
      if (!dist) return;

      // 1. Wait approx 1.5 seconds while card remains visible
      row._ardStartTimer = setTimeout(function () {
        if (!row._ardIsVisible) return;

        // 2. Animate horizontally across measured distance
        row.classList.add('is-scrolling-forward');

        // 3. Pause approx 1 second at the end
        var forwardMs = (row._ardOverflowDur || 1.5) * 1000;
        row._ardPauseTimer = setTimeout(function () {
          if (!row._ardIsVisible) return;

          // 4. Smoothly return to starting position
          row.classList.remove('is-scrolling-forward');
          row.classList.add('is-returning');

          // 5. Clean up after return animation (650ms)
          row._ardReturnTimer = setTimeout(function () {
            row.classList.remove('is-returning');
            row._ardPlayed = true;
          }, 650);
        }, forwardMs + 1000);
      }, 1500);
    }

    function getActiveTitleRow(card) {
      if (!card) return null;
      var swiper = card.querySelector('.collectible-products-swiper');
      if (swiper) {
        var activeSlide = swiper.querySelector('.collectible-products-swiper-slide.swiper-slide-active');
        if (activeSlide) {
          return activeSlide.querySelector('.ard-title-row');
        }
      }
      return card.querySelector('.ard-title-row');
    }

    var cardObserver = null;
    if ('IntersectionObserver' in window) {
      cardObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            var row = getActiveTitleRow(card);
            if (!row) return;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              row._ardIsVisible = true;
              if (!row._ardPlayed) {
                playAutoRevealCycle(row);
              }
            } else {
              row._ardIsVisible = false;
              row._ardPlayed = false;
              resetRowAnimation(row);
            }
          });
        },
        { threshold: [0, 0.2, 0.5] }
      );
    }

    function observeCards() {
      var cards = document.querySelectorAll('.product-block, .collection-block');
      cards.forEach(function (card) {
        if (cardObserver) {
          cardObserver.observe(card);
        }
        var rows = card.querySelectorAll('.ard-title-row');
        rows.forEach(function (row) {
          checkRowOverflow(row);
        });
      });
    }

    window.onArditiSeriesSlideChange = function (swiperEl) {
      if (!swiperEl) return;
      var card = swiperEl.closest('.product-block');
      if (!card) return;

      var allRows = card.querySelectorAll('.ard-title-row');
      allRows.forEach(function (r) {
        r._ardIsVisible = false;
        resetRowAnimation(r);
      });

      var activeRow = getActiveTitleRow(card);
      if (!activeRow) return;

      activeRow._ardPlayed = false;
      var rect = card.getBoundingClientRect();
      var inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (inView) {
        activeRow._ardIsVisible = true;
        playAutoRevealCycle(activeRow);
      }
    };

    window.updateArditiTitleOverflows = function () {
      observeCards();
    };

    var debounceTimer = null;
    function debouncedRefresh() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(window.updateArditiTitleOverflows, 120);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(debouncedRefresh);
    }

    [
      'DOMContentLoaded',
      'shopify:section:load',
      'cc-collection-filter:rendered',
      'ajaxinate:loaded',
      'infiniteScroll:loaded',
      'popstate',
    ].forEach(function (ev) {
      document.addEventListener(ev, debouncedRefresh);
    });

    window.addEventListener('resize', debouncedRefresh);

    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      setTimeout(debouncedRefresh, 80);
    }
  })();

/* 3. Collectible Swipers & Editorial Stack Module */
(function initCollectibleSwipersModule() {
    if (window.__COLLECTIBLE_SWIPERS_SYSTEM_LOADED__) return;
    window.__COLLECTIBLE_SWIPERS_SYSTEM_LOADED__ = true;

    function setNavAria(prev, next) {
      if (!prev || !next) return;
      prev.setAttribute('aria-disabled', prev.classList.contains('swiper-button-disabled') ? 'true' : 'false');
      next.setAttribute('aria-disabled', next.classList.contains('swiper-button-disabled') ? 'true' : 'false');
    }

    function forceLoadLazyImages(scope) {
      var root = scope || document;
      var imgs = root.querySelectorAll(
        '.swiper-slide.swiper-slide-active img, .swiper-slide.swiper-slide-next img, .swiper-slide.swiper-slide-prev img'
      );
      imgs.forEach(function (img) {
        if (!img) return;
        var ds = img.getAttribute('data-src');
        if (ds && (!img.src || img.src.indexOf('data:') === 0 || img.naturalWidth === 0)) {
          img.src = ds.replace('{width}', '540');
        }
        if (img.classList.contains('lazyload') && window.lazySizes) {
          window.lazySizes.loader.unveil(img);
        }
      });
    }

    /* --- Collectible Swiper Slide Hover Image Controller --- */
    (function initCollectibleSlideHoverSystem() {
      var WIDTHS = [460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
      var SLIDE_DURATION = 1000;

      function getResolvedImageUrl(templateUrl, containerWidth) {
        var isRetina = window.devicePixelRatio && window.devicePixelRatio > 1;
        var targetWidth = isRetina ? containerWidth * 2 : containerWidth;
        for (var i = 0; i < WIDTHS.length; i++) {
          if (WIDTHS[i] >= targetWidth) {
            return templateUrl.replace('{width}', WIDTHS[i]);
          }
        }
        return templateUrl.replace('{width}', WIDTHS[WIDTHS.length - 1]);
      }

      function initSlideGalleryImages(slide) {
        if (slide.dataset.sliderLoaded === 'true') return;
        var rawImages = slide.dataset.productImages;
        if (!rawImages) return;

        var imgContainer = slide.querySelector('.image-inner');
        if (!imgContainer) return;

        var imagesArr = rawImages.split(',').filter(Boolean);
        if (imagesArr.length <= 1) return;

        var containerWidth = slide.clientWidth || 300;
        var sliderHtml = '';
        imagesArr.forEach(function (imgUrl) {
          var resolved = getResolvedImageUrl(imgUrl, containerWidth);
          sliderHtml += '<img class="product-block--slide" tabindex="-1" src="' + resolved + '" alt="" />';
        });

        imgContainer.insertAdjacentHTML('beforeend', sliderHtml);
        slide.dataset.sliderLoaded = 'true';
      }

      function stopCollectibleSlideHover(slide) {
        if (slide._hoverTimer) {
          clearTimeout(slide._hoverTimer);
          slide._hoverTimer = null;
        }
        var imageContainer = slide.querySelector('.image-inner');
        if (imageContainer) {
          var activeSlide = imageContainer.querySelector('.product-block--slide.-in');
          if (activeSlide) {
            activeSlide.classList.remove('-in');
          }
          var firstImg = imageContainer.querySelector('.image__first');
          if (firstImg) {
            firstImg.classList.remove('-out');
          }
        }
        var imageBox = slide.querySelector('.image');
        if (imageBox) {
          var bar = imageBox.querySelector('.loading-bar');
          if (bar) bar.remove();
        }
      }

      function startCollectibleSlideHover(slide) {
        stopCollectibleSlideHover(slide);
        initSlideGalleryImages(slide);

        var imageContainer = slide.querySelector('.image-inner');
        var imageBox = slide.querySelector('.image');
        if (!imageContainer || !imageBox) return;

        var slides = imageContainer.querySelectorAll('.product-block--slide');
        if (!slides || slides.length <= 1) return;

        var loadingBarDelay = 100;
        var transitionDuration = slides.length * SLIDE_DURATION - loadingBarDelay;
        var loadingBar = document.createElement('div');
        loadingBar.classList.add('loading-bar');
        loadingBar.style.transitionDuration = transitionDuration + 'ms';
        imageBox.appendChild(loadingBar);
        setTimeout(function () {
          if (loadingBar.parentNode) {
            loadingBar.classList.add('-in');
          }
        }, loadingBarDelay);

        function step() {
          slide._hoverTimer = setTimeout(function () {
            var currentIn = imageContainer.querySelector('.product-block--slide.-in');
            var firstImg = imageContainer.querySelector('.image__first');

            if (!currentIn) {
              if (firstImg) firstImg.classList.add('-out');
              if (slides[1]) slides[1].classList.add('-in');
            } else {
              for (var i = 0; i < slides.length; i++) {
                if (slides[i].classList.contains('-in')) {
                  slides[i].classList.remove('-in');
                  if (i === slides.length - 1) {
                    var bar = imageBox.querySelector('.loading-bar');
                    if (bar) bar.remove();
                    slides[0].classList.add('-in');
                    var newBar = document.createElement('div');
                    newBar.classList.add('loading-bar');
                    newBar.style.transitionDuration = transitionDuration + 'ms';
                    imageBox.appendChild(newBar);
                    setTimeout(function () {
                      if (newBar.parentNode) newBar.classList.add('-in');
                    }, loadingBarDelay);
                  } else {
                    if (slides[i + 1]) slides[i + 1].classList.add('-in');
                  }
                  break;
                }
              }
            }
            step();
          }, SLIDE_DURATION);
        }

        step();
      }

      document.addEventListener('mouseover', function (e) {
        if (window.innerWidth < 768) return;
        var imageBox = e.target.closest('.collectible-products-swiper .swiper-slide .image');
        if (!imageBox) return;
        var slide = imageBox.closest('.swiper-slide');
        if (!slide || !slide.dataset.productImages) return;
        var stackOwner = slide.closest('.collectible-products-swiper--editorial-stack');
        if (stackOwner && (!slide.classList.contains('is-stack-front') || stackOwner.dataset.stackAnimating === '1'))
          return;

        if (slide._isHovered) return;
        slide._isHovered = true;
        startCollectibleSlideHover(slide);
      });

      document.addEventListener('mouseout', function (e) {
        var imageBox = e.target.closest('.collectible-products-swiper .swiper-slide .image');
        if (!imageBox) return;
        var related = e.relatedTarget;
        if (imageBox.contains(related)) return;

        var slide = imageBox.closest('.swiper-slide');
        if (!slide) return;
        slide._isHovered = false;
        stopCollectibleSlideHover(slide);
      });

      window.resetCollectibleSwiperSlideHovers = function (swiperEl) {
        if (!swiperEl) return;
        swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
          slide._isHovered = false;
          stopCollectibleSlideHover(slide);
        });
      };
    })();

    var collectibleObserver = null;
    if ('IntersectionObserver' in window) {
      collectibleObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              observer.unobserve(entry.target);
              initSingleCollectibleSwiper(entry.target);
            }
          });
        },
        {
          rootMargin: '300px 0px',
          threshold: 0.01,
        }
      );
    }

    function initEditorialCardStackProto(el) {
      if (!el || el.dataset.stackInit === '1') return;
      el.dataset.stackInit = '1';
      el.dataset.swiperInit = '1';

      // Canonical distinct sibling products only (never count Swiper loop clones or duplicate handles)
      var rawSlides = Array.from(
        el.querySelectorAll('.collectible-products-swiper-slide:not(.swiper-slide-duplicate)')
      );
      var seenHandles = Object.create(null);
      var slides = [];
      rawSlides.forEach(function (s) {
        var h = s.getAttribute('data-product-handle') || '';
        if (h && seenHandles[h]) {
          s.remove();
          return;
        }
        if (h) seenHandles[h] = true;
        slides.push(s);
      });

      var count = slides.length;
      if (count <= 1) return;

      var cardRoot = el.closest('.product-block');
      if (cardRoot) {
        cardRoot.classList.add('-in', 'cc-animate-complete');
      }
      var activeIndex = 0;
      var isAnimating = false;
      var transitionSeq = 0;
      var phaseTimer = null;
      var unlockTimer = null;
      var TRANSIENT_CLASSES = [
        'is-stack-leaving-out',
        'is-stack-tuck-prep',
        'is-stack-tuck-in',
        'is-stack-enter-prep',
        'is-stack-enter-prep-near',
        'is-stack-returning-front',
        'is-stack-stepping-back',
      ];
      var CONTAINER_TRANSIENT_CLASSES = [
        'is-stack-nav-next-p1',
        'is-stack-nav-next-p2',
        'is-stack-nav-prev-p1',
        'is-stack-nav-prev-p2',
      ];

      // Preload & unveil all sibling card photographs (including Showcase lazyload--manual slides)
      el.querySelectorAll('img').forEach(function (img) {
        img.removeAttribute('loading');
        if (img.classList.contains('lazyload--manual')) {
          img.classList.remove('lazyload--manual');
          img.classList.add('lazyload');
        }
        var ds = img.getAttribute('data-src');
        if (ds && (!img.src || img.src.indexOf('data:') === 0 || img.naturalWidth === 0)) {
          img.src = ds.replace('{width}', '720');
        }
        if (img.classList.contains('lazyload') && window.lazySizes && window.lazySizes.loader) {
          try {
            window.lazySizes.loader.unveil(img);
          } catch (err) {}
        }
        img.classList.add('lazyloaded');
        var rWrap = img.closest('.rimage-wrapper');
        if (rWrap) {
          rWrap.classList.remove('lazyload--placeholder');
        }
      });

      function clearPendingTimers() {
        if (phaseTimer !== null) {
          clearTimeout(phaseTimer);
          phaseTimer = null;
        }
        if (unlockTimer !== null) {
          clearTimeout(unlockTimer);
          unlockTimer = null;
        }
      }

      function stripAllTransientClasses() {
        slides.forEach(function (slide) {
          TRANSIENT_CLASSES.forEach(function (cls) {
            slide.classList.remove(cls);
          });
        });
        CONTAINER_TRANSIENT_CLASSES.forEach(function (cls) {
          el.classList.remove(cls);
        });
      }

      function setSlideInteractivity(slide, isFront) {
        if (isFront) {
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('inert');
          slide.querySelectorAll('a, button').forEach(function (ctrl) {
            if (ctrl.classList.contains('image-inner')) {
              ctrl.setAttribute('tabindex', '-1');
            } else {
              ctrl.removeAttribute('tabindex');
            }
          });
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
          slide.querySelectorAll('a, button').forEach(function (ctrl) {
            ctrl.setAttribute('tabindex', '-1');
          });
        }
      }

      function updateStackClasses(focusSelector) {
        slides.forEach(function (slide, idx) {
          var depth = (idx - activeIndex + count) % count;

          // Keep canonical X / N OPTIONS counter synced on every real sibling card
          var indexSpan = slide.querySelector('.ard-stack-nav-index');
          var labelSpan = slide.querySelector('.ard-stack-nav-label');
          if (indexSpan) {
            indexSpan.textContent = idx + 1 + ' / ' + count;
          }
          if (labelSpan) {
            labelSpan.textContent = 'OPTIONS';
          }

          slide.classList.remove(
            'is-stack-front',
            'is-stack-layer-1',
            'is-stack-layer-2',
            'is-stack-hidden',
            'swiper-slide-active'
          );

          if (depth === 0) {
            slide.classList.add('is-stack-front', 'swiper-slide-active');
            setSlideInteractivity(slide, true);
          } else if (depth === 1) {
            slide.classList.add('is-stack-layer-1');
            setSlideInteractivity(slide, false);
          } else if (depth === 2) {
            slide.classList.add('is-stack-layer-2');
            setSlideInteractivity(slide, false);
          } else {
            slide.classList.add('is-stack-hidden');
            setSlideInteractivity(slide, false);
          }
        });

        var activeSlide = slides[activeIndex];
        if (cardRoot && activeSlide) {
          if (activeSlide.dataset.productHandle) {
            cardRoot.dataset.ardProductHandle = activeSlide.dataset.productHandle;
          }
          if (activeSlide.dataset.productUrl) {
            cardRoot.dataset.ardProductUrl = activeSlide.dataset.productUrl;
          }
        }

        if (focusSelector && activeSlide) {
          var nextFocusEl = activeSlide.querySelector(focusSelector);
          if (nextFocusEl && typeof nextFocusEl.focus === 'function') {
            nextFocusEl.focus({ preventScroll: true });
          }
        }

        if (window.onArditiSeriesSlideChange) {
          window.onArditiSeriesSlideChange(el);
        } else if (window.updateArditiTitleOverflows) {
          window.updateArditiTitleOverflows();
        }
      }

      // Deterministically snaps any in-flight animation to the exact canonical state of activeIndex
      function settleActiveTransitionImmediately() {
        transitionSeq++;
        clearPendingTimers();
        el.classList.add('is-stack-settling');
        stripAllTransientClasses();
        updateStackClasses();
        void el.offsetWidth;
        el.classList.remove('is-stack-settling');
        isAnimating = false;
        el.dataset.stackAnimating = '0';
      }

      function finalizeCanonicalState(seq) {
        if (seq !== transitionSeq) return;
        clearPendingTimers();
        stripAllTransientClasses();
        isAnimating = false;
        el.dataset.stackAnimating = '0';
      }

      function goNext(focusSelector) {
        if (isAnimating) {
          settleActiveTransitionImmediately();
        }
        var mySeq = ++transitionSeq;
        isAnimating = true;
        el.dataset.stackAnimating = '1';

        if (window.resetCollectibleSwiperSlideHovers) {
          window.resetCollectibleSwiperSlideHovers(el);
        }

        var outgoing = slides[activeIndex];
        var nextIndex = (activeIndex + 1) % count;

        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) {
          activeIndex = nextIndex;
          stripAllTransientClasses();
          updateStackClasses(focusSelector);
          isAnimating = false;
          el.dataset.stackAnimating = '0';
          return;
        }

        // Phase 1 (0–240ms): outgoing front card glides out while incoming sibling & middle layer step forward over 520ms
        if (count === 2) {
          el.classList.add('is-stack-nav-next-p1');
        }
        outgoing.classList.add('is-stack-leaving-out');
        activeIndex = nextIndex;
        updateStackClasses(focusSelector);

        // Phase 2 (240–525ms): at zero opacity, tuck outgoing card behind the deck without z-index pop
        phaseTimer = setTimeout(function () {
          if (mySeq !== transitionSeq) return;
          phaseTimer = null;
          if (count === 2) {
            el.classList.remove('is-stack-nav-next-p1');
            el.classList.add('is-stack-nav-next-p2');
          }
          if (outgoing.classList.contains('is-stack-hidden')) {
            outgoing.classList.remove('is-stack-leaving-out');
          } else {
            outgoing.classList.add('is-stack-tuck-prep');
            outgoing.classList.remove('is-stack-leaving-out');
            void outgoing.offsetWidth;
            outgoing.classList.add('is-stack-tuck-in');
            outgoing.classList.remove('is-stack-tuck-prep');
          }

          unlockTimer = setTimeout(function () {
            finalizeCanonicalState(mySeq);
          }, 285);
        }, 240);
      }

      function goPrev(focusSelector) {
        if (isAnimating) {
          settleActiveTransitionImmediately();
        }
        var mySeq = ++transitionSeq;
        isAnimating = true;
        el.dataset.stackAnimating = '1';

        if (window.resetCollectibleSwiperSlideHovers) {
          window.resetCollectibleSwiperSlideHovers(el);
        }

        var prevIndex = (activeIndex - 1 + count) % count;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) {
          activeIndex = prevIndex;
          stripAllTransientClasses();
          updateStackClasses(focusSelector);
          isAnimating = false;
          el.dataset.stackAnimating = '0';
          return;
        }

        // Natural stack-axis reverse: outgoing front card steps back keeping its chrome intact while rear sibling glides forward from its rear stack offset onto (0, 0)
        if (count === 2) {
          el.classList.add('is-stack-nav-prev-p1');
        }
        var outgoing = slides[activeIndex];
        var incoming = slides[prevIndex];
        var prepClass = count === 2 ? 'is-stack-enter-prep-near' : 'is-stack-enter-prep';
        outgoing.classList.add('is-stack-stepping-back');
        incoming.classList.add(prepClass);
        activeIndex = prevIndex;
        updateStackClasses(focusSelector);
        void incoming.offsetWidth;
        incoming.classList.add('is-stack-returning-front');
        incoming.classList.remove(prepClass);

        if (count === 2) {
          phaseTimer = setTimeout(function () {
            if (mySeq !== transitionSeq) return;
            phaseTimer = null;
            el.classList.remove('is-stack-nav-prev-p1');
            el.classList.add('is-stack-nav-prev-p2');
          }, 240);
        }

        unlockTimer = setTimeout(function () {
          finalizeCanonicalState(mySeq);
        }, 540);
      }

      el._goNext = goNext;
      el._goPrev = goPrev;
      el._settleStack = settleActiveTransitionImmediately;
      el._cleanupStack = clearPendingTimers;
      el._getActiveIndex = function () {
        return activeIndex;
      };
      el._getDistinctCount = function () {
        return count;
      };
      el._setActiveIndex = function (idx) {
        settleActiveTransitionImmediately();
        activeIndex = ((idx % count) + count) % count;
        updateStackClasses();
      };

      el.dataset.stackAnimating = '0';
      updateStackClasses();

      // Suppress accidental link clicks immediately following a horizontal swipe gesture
      var lastSwipeAt = 0;
      el.addEventListener(
        'click',
        function (e) {
          if (lastSwipeAt > 0 && Date.now() - lastSwipeAt < 360) {
            if (!e.target.closest('.ard-stack-nav-btn, .ard-qv-card-trigger')) {
              e.preventDefault();
              e.stopPropagation();
              lastSwipeAt = 0;
              return;
            }
          }
        },
        true
      );

      // Single delegated navigation controller for the Options Counter / Navigation Band
      el.addEventListener('click', function (e) {
        var nextBtn = e.target.closest('.ard-stack-nav-next');
        if (nextBtn) {
          e.preventDefault();
          e.stopPropagation();
          var keepFocusNext = e.detail === 0 || document.body.classList.contains('user-is-tabbing');
          goNext(keepFocusNext ? '.ard-stack-nav-next' : null);
          return;
        }

        var prevBtn = e.target.closest('.ard-stack-nav-prev');
        if (prevBtn) {
          e.preventDefault();
          e.stopPropagation();
          var keepFocusPrev = e.detail === 0 || document.body.classList.contains('user-is-tabbing');
          goPrev(keepFocusPrev ? '.ard-stack-nav-prev' : null);
        }
      });

      var touchActive = false;
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartTime = 0;

      el.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || e.touches.length !== 1) {
            touchActive = false;
            return;
          }
          // Never compete with button taps in the navigation overlay or Quick View trigger
          var touchOrigin = (e.touches[0] && e.touches[0].target) || e.target;
          if (
            touchOrigin &&
            touchOrigin.closest &&
            touchOrigin.closest('.ard-stack-nav-band, .ard-stack-nav-btn, .ard-qv-card-trigger')
          ) {
            touchActive = false;
            return;
          }
          touchActive = true;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchStartTime = Date.now();
        },
        { passive: true }
      );

      el.addEventListener(
        'touchmove',
        function (e) {
          if (!touchActive || !e.touches || e.touches.length !== 1) {
            touchActive = false;
          }
        },
        { passive: true }
      );

      el.addEventListener(
        'touchcancel',
        function () {
          touchActive = false;
        },
        { passive: true }
      );

      el.addEventListener(
        'touchend',
        function (e) {
          if (!touchActive || !e.changedTouches || e.changedTouches.length === 0) {
            touchActive = false;
            return;
          }
          touchActive = false;
          var deltaX = e.changedTouches[0].clientX - touchStartX;
          var deltaY = e.changedTouches[0].clientY - touchStartY;
          var duration = Date.now() - touchStartTime;

          if (Math.abs(deltaX) > 30 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2 && duration < 650) {
            lastSwipeAt = Date.now();
            if (deltaX < 0) {
              goNext();
            } else {
              goPrev();
            }
          }
        },
        { passive: true }
      );
    }

    function initSingleCollectibleSwiper(el) {
      if (!el || el.dataset.swiperInit === '1' || el.dataset.stackInit === '1') return;

      if (el.classList.contains('collectible-products-swiper--editorial-stack')) {
        initEditorialCardStackProto(el);
        return;
      }

      if (typeof window.Swiper === 'undefined') return;

      var prev =
        el.querySelector('.swiper-button-prev') ||
        (el.parentNode ? el.parentNode.querySelector('.swiper-button-prev') : null);
      var next =
        el.querySelector('.swiper-button-next') ||
        (el.parentNode ? el.parentNode.querySelector('.swiper-button-next') : null);

      var swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 24,
        watchOverflow: true,
        loop: false,
        preloadImages: false,
        lazy: { enabled: true, loadOnTransitionStart: true, loadPrevNext: true, loadPrevNextAmount: 1 },
        navigation: { nextEl: next, prevEl: prev },
        observer: false,
        observeParents: false,
        on: {
          init: function () {
            el.dataset.swiperInit = '1';
            if (prev && next) setNavAria(prev, next);
            try {
              forceLoadLazyImages(el);
            } catch (e) {}
          },
          slideChangeTransitionStart: function () {
            forceLoadLazyImages(el);
            if (window.resetCollectibleSwiperSlideHovers) {
              window.resetCollectibleSwiperSlideHovers(el);
            }
          },
          slideChangeTransitionEnd: function () {
            if (window.onArditiSeriesSlideChange) {
              window.onArditiSeriesSlideChange(el);
            } else if (window.updateArditiTitleOverflows) {
              window.updateArditiTitleOverflows();
            }
          },
          slideChange: function () {
            if (prev && next) setNavAria(prev, next);
            if (window.resetCollectibleSwiperSlideHovers) {
              window.resetCollectibleSwiperSlideHovers(el);
            }
            if (window.onArditiSeriesSlideChange) {
              window.onArditiSeriesSlideChange(el);
            }
          },
          reachBeginning: function () {
            if (prev && next) setNavAria(prev, next);
          },
          reachEnd: function () {
            if (prev && next) setNavAria(prev, next);
          },
          fromEdge: function () {
            if (prev && next) setNavAria(prev, next);
          },
          lazyImageError: function (swiperInstance, slideEl, imageEl) {
            if (imageEl && imageEl.dataset && imageEl.dataset.src) {
              imageEl.src = imageEl.dataset.src;
            }
          },
        },
      });
    }

    window.initCollectibleSwipers = function initCollectibleSwipers() {
      // Eagerly initialize any stack prototypes first
      document.querySelectorAll('.collectible-products-swiper--editorial-stack').forEach(function (el) {
        if (el.dataset.stackInit !== '1') {
          initEditorialCardStackProto(el);
        }
      });

      if (typeof window.Swiper === 'undefined') {
        setTimeout(initCollectibleSwipers, 80);
        return;
      }

      var elements = document.querySelectorAll('.collectible-products-swiper');
      elements.forEach(function (el) {
        if (el.dataset.swiperInit === '1' || el.dataset.stackInit === '1') return;

        if (collectibleObserver) {
          collectibleObserver.observe(el);
        } else {
          initSingleCollectibleSwiper(el);
        }
      });
    };

    [
      'DOMContentLoaded',
      'shopify:section:load',
      'ajaxinate:loaded',
      'cc-collection-filter:rendered',
      'infiniteScroll:loaded',
      'popstate',
    ].forEach(function (ev) {
      document.addEventListener(ev, function () {
        setTimeout(window.initCollectibleSwipers, 60);
      });
    });

    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      setTimeout(window.initCollectibleSwipers, 60);
    }

    /* MutationObserver for dynamically added product cards & global stack lifecycle */
    (function observeCollectibleSwipersMount() {
      if (window.__ARD_SWIPER_OBSERVER__) return;
      window.__ARD_SWIPER_OBSERVER__ = true;

      function settleAllAnimatingStacks() {
        document
          .querySelectorAll('.collectible-products-swiper--editorial-stack[data-stack-animating="1"]')
          .forEach(function (el) {
            if (typeof el._settleStack === 'function') {
              el._settleStack();
            }
          });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          settleAllAnimatingStacks();
        }
      });

      window.addEventListener('resize', settleAllAnimatingStacks, { passive: true });

      var debounceTimer = null;
      var shouldTrigger = function (n) {
        if (!n || n.nodeType !== 1) return false;
        if (n.matches && n.matches('.collectible-products-swiper')) return true;
        if (n.querySelector && n.querySelector('.collectible-products-swiper')) return true;
        return false;
      };

      var cleanupNodeStacks = function (n) {
        if (!n || n.nodeType !== 1) return;
        if (
          n.matches &&
          n.matches('.collectible-products-swiper--editorial-stack') &&
          typeof n._cleanupStack === 'function'
        ) {
          n._cleanupStack();
        }
        if (n.querySelectorAll) {
          n.querySelectorAll('.collectible-products-swiper--editorial-stack').forEach(function (el) {
            if (typeof el._cleanupStack === 'function') {
              el._cleanupStack();
            }
          });
        }
      };

      var mo = new MutationObserver(function (mutations) {
        var needsInit = false;
        for (var i = 0; i < mutations.length; i++) {
          var removed = mutations[i].removedNodes;
          for (var r = 0; r < removed.length; r++) {
            cleanupNodeStacks(removed[r]);
          }
          if (!needsInit) {
            var added = mutations[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              if (shouldTrigger(added[j])) {
                needsInit = true;
                break;
              }
            }
          }
        }
        if (needsInit) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            if (window.initCollectibleSwipers) window.initCollectibleSwipers();
          }, 60);
        }
      });

      mo.observe(document.body, { childList: true, subtree: true });
    })();

    /* Event delegation for navigation buttons (disabled swallow + on-demand init) */
    function swallow(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      return false;
    }

    ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
      document.addEventListener(
        evt,
        function (e) {
          var stackBtn = e.target.closest('.ard-stack-nav-btn');
          if (stackBtn) {
            var stackEl = stackBtn.closest('.collectible-products-swiper--editorial-stack');
            if (stackEl && stackEl.dataset.stackInit !== '1') {
              initEditorialCardStackProto(stackEl);
            }
            return;
          }

          var btn = e.target.closest('.swiper-button-prev, .swiper-button-next');
          if (!btn) return;

          if (btn.classList.contains('swiper-button-disabled')) {
            swallow(e);
            return;
          }

          var swiperEl =
            btn.closest('.collectible-products-swiper') ||
            (btn.parentNode ? btn.parentNode.querySelector('.collectible-products-swiper') : null);
          if (swiperEl) {
            if (
              swiperEl.dataset.stackInit === '1' ||
              swiperEl.classList.contains('collectible-products-swiper--editorial-stack')
            ) {
              if (swiperEl.dataset.stackInit !== '1') {
                initEditorialCardStackProto(swiperEl);
              }
              if (evt === 'click') {
                if (btn.classList.contains('swiper-button-next') && swiperEl._goNext) {
                  swallow(e);
                  swiperEl._goNext();
                  return;
                }
                if (btn.classList.contains('swiper-button-prev') && swiperEl._goPrev) {
                  swallow(e);
                  swiperEl._goPrev();
                  return;
                }
              }
              swallow(e);
              return;
            }

            if (swiperEl.dataset.swiperInit !== '1') {
              if (collectibleObserver) collectibleObserver.unobserve(swiperEl);
              initSingleCollectibleSwiper(swiperEl);
            }
          }
        },
        true
      );
    });
  })();
